<template>
  <div
    class="relative text-3xl md:text-6xl xxl:text-7xl leading-none text-primary lg:mt-16"
  >
    <h1>
      <span
        class="bg-white inline-block px-3 md:px-6 pb-2 pt-4"
        v-html="info.first_line"
      />
      <br>
      <span
        class="bg-white inline-block px-3 md:px-6 py-1 md:py-2"
        v-html="info.second_line"
      />
      <br>
      <span
        class="font-bold bg-white inline-block px-3 md:px-6 pt-2 pb-4"
        v-html="info.third_line"
      />
    </h1>

    <div class="lg:flex mt-7vw">
      <ButtonMain
        v-for="(cta, i) in info.calls_to_action"
        :key="`more-info-ctas-${i}`"
        :type="'external'"
        :cta="cta.text"
        :icon="cta.icon"
        :size="!mobile ? '32px' : '24px'"
        :path="utmHref(cta.linkout, 'tier-1-cta')"
        class="h-16 px-6 mb-3 lg:mr-5 w-full xl:w-72 xxl:w-84"
      />
    </div>
    <div class="lg:flex">
      <a
        id="liveagent_button_online_5731t000000gOJV"
        href="javascript://Chat"
        class="button text-base xl:text-lg btn-hover h-16 px-6 mb-3 lg:mr-5 w-full xl:w-72 xxl:w-84"
        style="display: none;"
        onclick="liveagent.startChat('5731t000000gOJV')"
      >
        Chat With Us (UK)
      </a>

      <a
        id="liveagent_button_offline_5731t000000gOJV"
        href="https://coventry-university.secure.force.com/CU_ChatOfflineSupport?queue=dom"
        target="_blank"
        class="button text-base xl:text-lg btn-hover h-16 px-6 mb-3 lg:mr-5 w-full xl:w-72 xxl:w-84"
        style="display: none;"
      >
        Contact Us (UK)
      </a>

      <a
        id="liveagent_button_online_5731t000000gOJa"
        href="javascript://Chat"
        class="button text-base xl:text-lg btn-hover h-16 px-6 mb-3 lg:mr-5 w-full xl:w-72 xxl:w-84"
        style="display: none;"
        onclick="liveagent.startChat('5731t000000gOJa')"
      >
        Chat With Us (International)
      </a>

      <a
        id="liveagent_button_offline_5731t000000gOJa"
        href="https://coventry-university.secure.force.com/CU_ChatOfflineSupport?queue=int"
        target="_blank"
        class="button text-base xl:text-lg btn-hover h-16 px-6 mb-3 lg:mr-5 w-full xl:w-72 xxl:w-84"
        style="display: none;"
      >
        Contact Us (International)
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import ButtonMain from '@/components/buttons/ButtonMain.vue'

export default {
  name: 'MoreInfo',

  components: {
    ButtonMain
  },

  computed: {
    ...mapGetters(['info']),
    ...mapState(['mobile'])
  },

  mounted() {
    const script = document.createElement('script')
    script.src
      = 'https://c.la1-c1-cdg.salesforceliveagent.com/content/g/js/48.0/deployment.js'
    script.id = 'salesforce'
    document.body.appendChild(script)
    script.onload = () => {
      this.initChatBtns()
    }
  },

  beforeDestroy() {
    delete window.liveagent
    delete window.liveAgentDeployment
    // this mock-agent suppresses errors causedby pending avail-checks
    window.liveagent = {
      _: {
        handlePing: () => {

          /* do nothing supress*/
        }
      }
    }
    // Anoyingly the script has to be added and removed each time
    document.getElementById('salesforce').remove()
  },

  methods: {
    initChatBtns() {
      liveagent.init(
        'https://d.la1-c1-cdg.salesforceliveagent.com/chat',
        '5721t000000gMys',
        '00D1t000000DDDy'
      )

      if (!window._laq) {
        window._laq = []
      }

      window._laq.push(function () {
        liveagent.showWhenOnline(
          '5731t000000gOJV',
          document.getElementById('liveagent_button_online_5731t000000gOJV')
        )

        liveagent.showWhenOffline(
          '5731t000000gOJV',
          document.getElementById('liveagent_button_offline_5731t000000gOJV')
        )
      })

      window._laq.push(function () {
        liveagent.showWhenOnline(
          '5731t000000gOJa',
          document.getElementById('liveagent_button_online_5731t000000gOJa')
        )

        liveagent.showWhenOffline(
          '5731t000000gOJa',
          document.getElementById('liveagent_button_offline_5731t000000gOJa')
        )
      })
    }
  }
}
</script>
